import classes from './HighlighterLink.module.scss'

export const HighlighterLink = ({ children }) => {
  return (
    <div className={classes.highlighter}>
      <div className={classes.highlighter__wrapper}>
        <span className={classes.highlighter__wrapper__text}>{children}</span>
        <div className={classes.highlighter__wrapper__stroke}></div>{' '}
      </div>
    </div>
  )
}
